import type { IGrowthOverviewTableRow } from "../types";

export const mergeRefreshedRootRows = (
    currentRows: IGrowthOverviewTableRow[],
    refreshedRootRows: IGrowthOverviewTableRow[],
): IGrowthOverviewTableRow[] => {
    if (currentRows.length <= refreshedRootRows.length) {
        return refreshedRootRows;
    }

    const refreshedById = new Map(refreshedRootRows.map((row) => [row.id, row]));

    return currentRows.map((row) => refreshedById.get(row.id) ?? row);
};

export const appendRowsWithDedup = (
    rows: IGrowthOverviewTableRow[],
    newRows: IGrowthOverviewTableRow[],
): IGrowthOverviewTableRow[] => {
    if (newRows.length === 0) {
        return rows;
    }

    const existingIds = new Set(rows.map((row) => row.id));
    const uniqueNewRows = newRows.filter((row) => !existingIds.has(row.id));

    return uniqueNewRows.length === 0 ? rows : [...rows, ...uniqueNewRows];
};
